import React from "react";
import ReactApexChart from "react-apexcharts";
import {
	Box,
	HStack,
	Flex,
	Text,
	Button,
	SimpleGrid,
	Badge,
	Link,
} from "@chakra-ui/react";
import { ArrowBackIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { chart1Config, chart2Config } from "./variables/LineChart";
import { Link as ReachLink } from "react-router-dom";

function IndexDetail() {
	return (
		<Box pt={{ base: "120px", md: "75px" }}>
			<HStack justify="space-between">
				<Flex align="center" gap={3}>
					<Link as={ReachLink} to="indexes">
						<ArrowBackIcon boxSize={6} />
					</Link>

					<Text fontSize="2xl" fontWeight="bold">
						Csvdata Statistics
					</Text>
				</Flex>
				<Flex gap={3}>
					<Button bg="#48484F">Upload document</Button>
					<Button rightIcon={<ChevronDownIcon />} bg="#48484F">
						Week
					</Button>
				</Flex>
			</HStack>
			<SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing="24px">
				<Flex
					direction="column"
					gap={10}
					bg="#33333B"
					p="24px"
					borderRadius="16px"
					mt={5}
				>
					<Text fontSize="2xl" fontWeight="bold">
						Vector Count
					</Text>
					<HStack>
						<Text fontSize="3xl" fontWeight="bold">
							13.535%
						</Text>
						<Badge colorScheme="green" fontSize="0.8em">
							+ 3.58%
						</Badge>
					</HStack>
					<Box>
						<ReactApexChart
							options={chart1Config.options}
							series={chart1Config.series}
							type="line"
						/>
					</Box>
				</Flex>
				<Flex
					direction="column"
					gap={10}
					bg="#33333B"
					p="24px"
					borderRadius="16px"
					mt={5}
				>
					<Text fontSize="2xl" fontWeight="bold">
						Requests
					</Text>
					<HStack>
						<Text fontSize="3xl" fontWeight="bold">
							462
						</Text>
						<Badge colorScheme="green">+ 12.5%</Badge>
					</HStack>
					<Box>
						<ReactApexChart
							options={chart2Config.options}
							series={chart2Config.series}
							type="line"
						/>
					</Box>
				</Flex>
			</SimpleGrid>
		</Box>
	);
}

export default IndexDetail;
